<template>
    <button :class="[
        'item__body__btn btn font-normal text-white font-extralight rounded-md px-4 py-2 lg:py-3 inline-block w-full lg:w-auto text-center',
        classes
        ]"
    >
        <slot />
    </button>
</template>

<script>
export default {
    props: ['classes']
}
</script>
